<div
  class="w-full flex justify-center items-center bg-cover bg-center bg-no-repeat bg-[url('/assets/images/Group_73.webp')] h-[230px] sm:h-[180px] relative"
>
  <div class="absolute inset-0 bg-black opacity-70"></div>
  <div
    class="grid xl:grid-cols-4 gap-y-3 items-center container px-3 md:px-0 mx-auto relative z-10"
  >
    <div>
      <button
        (click)="goBack()"
        type="button"
        class="flex items-center text-white cursor-pointer"
      >
        <span class="mr-2">&larr;</span>
        <span>Back</span>
      </button>
    </div>

    <div
      class="xl:col-span-2 sm:w-fit w-full flex flex-col sm:items-center p-3 sm:p-0 space-y-2 sm:space-y-0 sm:flex-row bg-white shadow-md rounded-xl sm:rounded-full sm:h-[45px] overflow-hidden border"
    >
      <div
        class="flex items-center sm:ps-4 sm:py-2 text-gray-400 sm:bg-blue-600 h-full z-40 relative sm:pe-8 sm:text-white"
      >
        <span
          class="w-7 h-7 flex items-center justify-center bg-blue-600 rounded-full text-sm font-bold border !border-white text-white"
        >
          1
        </span>
        <span class="ml-2 font-medium text-blue-600 sm:text-white"
          >Listing Details</span
        >
        <span
          class="absolute right-2 size-[34px] border-t border-r !border-white rotate-45 hidden sm:block z-10"
        ></span>
      </div>

      <div
        class="flex items-center sm:ps-4 sm:py-2 sm:bg-blue-600 h-full z-40 relative text-white"
      >
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border bg-blue-600"
        >
          2
        </span>
        <span class="ml-2 font-medium text-blue-600 sm:text-white"
          >Add Photos</span
        >
      </div>

      <span
        class="me-3 text-gray-400 size-[34px] -ml-4 border-t border-r !border-white rotate-45 hidden sm:block bg-blue-600"
      ></span>

      <div class="flex sm:items-center text-gray-400 sm:pe-4 sm:ps-2 sm:py-2">
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border !border-blue-600 text-blue-600"
        >
          3
        </span>
        <span class="ml-2 font-medium text-blue-500 text-sm">Checkout</span>
      </div>
    </div>

    <div class="justify-center items-center gap-5 hidden xl:flex">
    </div>
  </div>
</div>

<div *ngIf="!finishedSelectingAds" class="container mx-auto px-3 py-10">
  <form [formGroup]="paymentForm" class="space-y-5">
    <div
      class="flex flex-row justify-start items-start gap-4 px-4 py-6 border shadow-[0_0_8px_rgba(0,0,0,0.03)]"
    >
      <!-- Parent Checkbox -->
      <input
        type="checkbox"
        class="size-5 accent-blue-600 base-listing-checkbox"
        id="create-ad"
        checked
        formControlName="createAd"
      />

      <div class="w-full">
        <label for="create-ad" class="font-semibold"
          >${{ totalPrice === 97 ? 47 : totalPrice }} Create Ad</label
        >

        <!-- Basic Ad (Required) -->
        <div
          class="mt-3 w-full"
          [ngClass]="{
            'border-b pb-4': paymentForm.controls['createAd'].value
          }"
        >
          <ul class="grid gap-x-10 gap-y-2 text-sm list-disc">
            <li>Includes Carfax Report ($44 value)</li>
            <li>Ad lasts for a year</li>
          </ul>
        </div>

        <!-- Optional Add-ons -->
        <div
          *ngIf="paymentForm.controls['createAd'].value"
          class="mt-4 text-sm accent-blue-600"
        >
          <p class="font-semibold">Optional Add-ons</p>

          <!-- Autocheck Report -->
          <label class="block mt-2">
            <input type="checkbox" formControlName="autocheck" />
            <span class="ml-2">Autocheck Report (+$20)</span>
          </label>

          <!-- Ad Management for Facebook/Google/YouTube -->
          <div class="flex justify-start items-start gap-2 mt-4">
            <input
              type="checkbox"
              id="adManagement"
              formControlName="adManagement"
            />
            <div class="flex flex-col items-start justify-start">
              <label for="adManagement"
                >Ad Management for Facebook/Google/YouTube - one time -
                ($100)</label
              >
              <ul class="list-disc ps-4 py-2 space-y-2 nth-last:list-none">
                <li>
                  We manage your ad on Facebook, Google, or YouTube so you don’t
                  have to. Includes designing, setting up, and running the paid
                  campaign.
                </li>
                <li>Covers our time to set up and monitor your ad campaign.</li>
                <li>
                  Required if you want us to actually handle paid ads on
                  Facebook/Google/YouTube.
                </li>
                <li
                  *ngIf="paymentForm.controls['adManagement'].value"
                  class="mt-3 font-medium -ml-5 last:list-none"
                >
                  <label class="block">
                    <span>Daily Ad Spend ($10 per day):</span>
                    <select class="ml-2 border p-1" formControlName="adSpend">
                      <option value="0">None</option>
                      <option value="10">10 days (+$100)</option>
                      <option value="20">20 days (+$200)</option>
                      <option value="30">30 days (+$300)</option>
                    </select>
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <!-- Publish on YouTube (+$25) -->
          <div class="flex justify-start items-start gap-2 mt-4">
            <input
              id="youtubePublish"
              type="checkbox"
              formControlName="youtubePublish"
            />
            <div class="flex flex-col items-start justify-start">
              <label for="youtubePublish">Publish on YouTube (+$25)</label>
              <ul class="list-disc ps-4 py-2 space-y-2">
                <li>We Publish Your Video on Our YouTube Channel.</li>
                <li>
                  We’ll host your ad on our YouTube channel to reach even more
                  buyers.
                </li>
                <!-- <li
                  *ngIf="paymentForm.controls['youtubePublish'].value"
                  class="mt-3 font-medium -ml-5 [&:nth-last-child(2)]:list-none"
                >
                  <label class="block mt-2">
                    <input type="checkbox" formControlName="hdVideo" />
                    <span class="ml-2"
                      >Add HD Video to Ad - we will send you a folder to upload
                      your videos - (+$25)</span
                    >
                  </label>
                </li> -->
                <li
                  *ngIf="
                    paymentForm.controls['youtubePublish'].value &&
                    paymentForm.controls['adManagement'].value
                  "
                  class="mt-3 font-medium -ml-5 last:list-none"
                >
                  <label class="block mt-2">
                    <span>Boost YouTube Video:</span>
                    <select
                      class="ml-2 border p-1"
                      formControlName="youtubeBoost"
                    >
                      <option value="0">None</option>
                      <option value="10">10 days (+$100)</option>
                      <option value="20">20 days (+$200)</option>
                      <option value="30">30 days (+$300)</option>
                    </select>
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <label class="block mt-2">
            <input type="checkbox" formControlName="hdVideo" />
            <span class="ml-2"
              >Add HD Video to Ad - we will send you a folder to upload your
              videos - (+$25)</span
            >
          </label>

          <label class="block mt-4">
            <input type="checkbox" formControlName="googleAds" />
            <span class="ml-2"
              >Advertise on Google (+$35 Setup Fee + $5/day)</span
            >
          </label>

          <div *ngIf="paymentForm.controls['googleAds'].value" class="mt-2">
            <label class="block">
              <span>Google Ads Budget:</span>
              <select class="ml-2 border p-1" formControlName="googleBudget">
                <option value="0">None</option>
                <option value="10">10 days (+$50)</option>
                <option value="20">20 days (+$100)</option>
                <option value="30">30 days (+$150)</option>
              </select>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- No Refund Agreement -->
    <div class="mt-6">
      <label class="block">
        <input
          type="checkbox"
          class="size-4 accent-blue-600"
          formControlName="noRefund"
        />
        <span class="ml-2 text-red-600"
          >I understand there are no refunds on any purchase.</span
        >
      </label>
    </div>

    <!-- Checkout Button -->
    <button
      class="mt-4 w-full py-4 text-white rounded lg:w-1/3 font-semibold flex justify-center items-center cursor-pointer disabled:cursor-not-allowed"
      [class.bg-blue-600]="paymentForm.controls['noRefund'].value"
      [class.bg-gray-400]="!paymentForm.controls['noRefund'].value"
      [class.cursor-not-allowed]="!paymentForm.controls['noRefund'].value"
      [disabled]="!paymentForm.controls['noRefund'].value || isSubmitting"
      (click)="submitForm()"
    >
      <span *ngIf="!isSubmitting">Checkout ${{ totalPrice }}</span>
      <span *ngIf="isSubmitting" class="flex items-center gap-2">
        <svg
          class="size-6 animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          />
          <path
            class="opacity-75"
            fill="none"
            stroke="currentColor"
            stroke-width="4"
            stroke-linecap="round"
            d="M12 2a10 10 0 0 1 0 20"
          />
        </svg>
        Processing...
      </span>
    </button>
  </form>
</div>

<div
  *ngIf="finishedSelectingAds"
  class="payment-container container mx-auto px-3 py-10"
>
  <form id="payment-form">
    <div id="payment-element"></div>
  </form>

  <div *ngIf="errorMessage" class="text-red-500 mt-4">
    {{ errorMessage }}
  </div>
</div>

<div class="container mx-auto px-3 pb-10">
  <button
    *ngIf="finishedSelectingAds"
    class="mb-4 w-fit py-4 px-5 text-white rounded font-medium flex justify-center items-center cursor-pointer disabled:cursor-not-allowed bg-blue-600 transition-transform duration-200 active:scale-95"
    (click)="backToEdit()"
  >
    Back To Checkout
  </button>
  <p>
    onlyusedtesla.com acts only as a vehicle listing service connecting buyers
    and sellers; the company does not own, buy or sell vehicles, and does not
    get involved in the transaction between buyer and seller, including by
    offering vehicle inspections, storage or shipping services.
  </p>
  <p>Customer acknowledges they understand that:</p>
  <ol class="list-disc pl-5 mt-2">
    <li>
      Listing their Tesla with onlyusedtesla.com does not guarantee a sale
    </li>
    <li>
      Any Tesla listed with onlyusedtesla that is sold through any other means
      does not entitle the customer to a refund of amounts paid to
      onlyusedtesla.com
    </li>
    <li>No swaps. No Refunds.</li>
  </ol>
</div>

<div
  *ngIf="checkingPaymentStatus"
  class="backdrop-blur-sm fixed z-50 left-0 top-0 w-screen bg-black h-full flex flex-col gap-3 items-center justify-center"
>
  <div role="status" class="relative flex justify-center">
    <svg xmlns="http://www.w3.org/2000/svg" class="size-28" viewBox="0 0 24 24">
      <path
        fill="#4d4d4d"
        d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z"
        opacity="0.5"
      />
      <path fill="#fff" d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z">
        <animateTransform
          attributeName="transform"
          dur="1s"
          from="0 12 12"
          repeatCount="indefinite"
          to="360 12 12"
          type="rotate"
        />
      </path>
    </svg>
    <img
      class="size-16 absolute top-1/2 left-1/2 p-2 rounded-full transform -translate-x-1/2 -translate-y-1/2 bg-white"
      src="assets/images/icon-out.svg"
      alt="Only Used Tesla Logo"
    />
  </div>
  <div
    class="flex flex-col justify-center items-center gap-2 !text-white z-50 relative"
  >
    <span
      class="text-2xl lg:text-3xl font-bold animate-pulse w-full text-center"
      >Payment Confirmation..</span
    >
    <p class="text-muted-foreground w-full text-center font-semibold">
      Please wait while we confirm your payment. this is take few seconds
    </p>
    <p class="flex items-center gap-3 justify-center text-muted-foreground">
      <span class="mt-1"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          class="size-4"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M12 2a5 5 0 0 1 5 5v3a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3V7a5 5 0 0 1 5-5m0 12a2 2 0 0 0-1.995 1.85L10 16a2 2 0 1 0 2-2m0-10a3 3 0 0 0-3 3v3h6V7a3 3 0 0 0-3-3"
          /></svg></span
      ><span>Secure Process</span>
    </p>
  </div>
</div>
